import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function FinalGuarantee() {
  return <section className="px-5 pt-2 pb-6" data-id="element-78" data-mp="39t3o3a1hmxfy">
      <div className="mx-auto max-w-md" data-id="element-79" data-mp="39u52nohpq22f">
        <div className="flex items-start gap-3 rounded-xl border border-[#F5C518]/30 bg-[#F5C518]/[0.07] p-4" data-id="element-80" data-mp="3njoyeacvlz28">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#F5C518] text-black" data-id="element-81" data-mp="3isqhb8k2cwxx">
            <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-82" data-mp="1bpe78wkw92m" />
          </span>
          <div data-id="element-83" data-mp="3sjuuq3u3c9qn">
            <h2 className="font-oswald text-sm font-700 uppercase tracking-wide text-white" data-id="element-84" data-mp="3si0bctygwpoo">
              Garantía de 7 días
            </h2>
            <p className="mt-1 text-[13px] leading-snug text-neutral-300" data-id="element-85" data-mp="ab2q0886d9qi">
              Pruébalo sin riesgo. Si no es para ti, solicita la devolución de tu
              compra durante los 7 días posteriores.
            </p>
          </div>
        </div>
      </div>
    </section>;
}